import React from 'react'
import { Text } from 'react-form'
import {Form, Col, FormGroup, Button, ControlLabel} from 'react-bootstrap'
import ProgressBar from '../Common/ProgressBar/ProgressBar'

export default ({submitForm, isLoading}) => {
  return (
    <Form horizontal onSubmit={submitForm}>
      <FormGroup>
        <Col componentClass={ControlLabel} sm={2}>
          نعل
        </Col>
        <Col sm={10}>
          <Text
            type="number"
            field="point"
            placeholder="1"
            className="form-control"
          />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col smOffset={2} sm={10}>
          <Button type="submit" className="btnBlock" bsStyle="success">
            ثبت
          </Button>
          <ProgressBar isLoading={isLoading} type="button" />
        </Col>
      </FormGroup>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/Feature/PointComponent.js